import React from 'react';


const Text = ({lang, language, str,html = false}) => {

    if(lang){
        if(html){
            return (
                <span dangerouslySetInnerHTML={{__html: language[lang][str]}}></span>
            );
        }


        if(language[lang][str]){
            return <>{language[lang][str]}</>;
        }else{
            return <>{str}</>;
        }

    }
    return <></>;


};
export default Text;
